import React, { useEffect, useState } from "react";

import FacebookPostPreview from "./FacebookPostPreview";
import InstagramPostPreview from "./InstagramPostPreview";
import LinkedinPostPreview from "./LinkedinPostPreview";
import TiktokPostPreview from "./TiktokPostPreview";

const SocialSharePreview = ({ userActivity, onUserActivityRemove, onUserActivityUpdate }) => {
  const [share, setShare] = useState(false);

  const { entity: socialShare } = userActivity;
  const { entity: story } = socialShare;

  useEffect(
    () => {
      setShare(socialShare);
    }, [socialShare]
  );

  const updateLinkedinShare = updatedLinkedinShare => {
    setShare(updatedLinkedinShare);
  };

  if (!share) {
    return <></>;
  }

  if (socialShare.socialType === "facebook") {
    return (
      <FacebookPostPreview
        story={story}
        userActivity={userActivity}
        facebookShare={share}
        onUserActivityRemove={onUserActivityRemove}
        onUserActivityUpdate={onUserActivityUpdate}
      />
    );
  }

  if (socialShare.socialType === "instagram") {
    return (
      <InstagramPostPreview
        story={story}
        userActivity={userActivity}
        instagramShare={share}
        onUserActivityRemove={onUserActivityRemove}
        onUserActivityUpdate={onUserActivityUpdate}
      />
    );
  }

  if (socialShare.socialType === "linkedin") {
    return (
      <LinkedinPostPreview
        linkedinShare={share}
        onUserActivityRemove={onUserActivityRemove}
        onUserActivityUpdate={onUserActivityUpdate}
        story={story}
        updateLinkedinShare={updateLinkedinShare}
        userActivity={userActivity}
      />
    );
  }

  if (socialShare.socialType === "tiktok") {
    return (
      <TiktokPostPreview
        story={story}
        userActivity={userActivity}
        tiktokShare={share}
        onUserActivityRemove={onUserActivityRemove}
        onUserActivityUpdate={onUserActivityUpdate}
      />
    );
  }

  return <></>;
};

export default SocialSharePreview;
